module.exports = __webpack_public_path__ + "static/wireframesMobile@2x-b7e05008b10c69225d437cdf68e4af7b.png";